<template>
  <div v-loading="showFlag">
    <t-card>
      <!-- 得意先見積タブ -->

      <div :style="{ height: basicHeight + 'px' }">
        <!-- 見積書出力ボタン と レート参照ボタン -->
        <t-row>
          <t-col :span="3" class="col_common_left">
            <!-- レート参照ボタン -->
            <t-button
              round
              type="primary"
              class="dialogButton_150_40"
              ref="rateReferenceBtn"
              @click="rateReferenceClick()"
              ><i class="el-icon-search"></i
              >{{ $t("resource.NUMBER.RATE_REFERENCE_BUTTON") }}
            </t-button></t-col
          >
          <t-col :span="21" class="right">
            <!-- 見積書出力ボタン -->
            <t-button
              round
              type="primary"
              class="dialogButton_150_40"
              ref="estimateOutputBtn"
              @click="estimateOutputClick()"
            >
              <i class="el-icon-download"></i
              >{{ $t("resource.NUMBER.ESTIMATE_OUTPUT_BUTTON") }}
            </t-button>
          </t-col>
        </t-row>
      </div>
      <!-- 得意先見積のテーブル -->
      <div>
        <t-table
          ref="customerTable"
          :data="customerTable"
          class="table_common"
          header-cell-class-name="bg-default"
          :height="detailHeight"
          highlight-current-row
          :cell-class-name="tableCellClassName"
          border
          fit
        >
          <!-- 得意先見積のテーブルの列 -->
          <t-table-column
            v-for="(column, index) in filteredColumns"
            :key="index"
            :type="column.type"
            :prop="column.prop"
            :label="column.label"
            :min-width="column.width"
            :class-name="column.class"
            :fixed="column.fixed"
            :show-overflow-tooltip="column.overflowTooltip"
          >
            <!-- :key="index"
            :label="column.label" -->
            <template v-if="column.children && column.children.length > 0">
              <t-table-column
                v-for="(columnSon, indexSon) in column.children"
                :key="indexSon"
                :type="columnSon.type"
                :prop="columnSon.prop"
                :label="columnSon.label"
                :min-width="columnSon.width"
                :class-name="columnSon.class"
                :show-overflow-tooltip="columnSon.overflowTooltip"
              >
                <template #default="scopeChildren">
                  <t-input
                    class="cell_input_custom"
                    v-if="
                      editCellData(scopeChildren.row, scopeChildren.column) ==
                      'input'
                    "
                    :maxLength="6"
                    v-model="scopeChildren.row[columnSon.prop]"
                    @focus="
                      changeCellDataToNumber(scopeChildren.row, columnSon.prop)
                    "
                    @input="
                      scopeChildren.row[columnSon.prop] = scopeChildren.row[
                        columnSon.prop
                      ].replace(/[^\d]/g, '')
                    "
                    @blur="changeCellData()"
                    :ref="`input${scopeChildren.row.index}-${columnSon.prop}`"
                    @keyup.native.enter="
                      focusNextInput(scopeChildren.row.index, columnSon.prop)
                    "
                  />
                  <t-input-number
                    class="cell_input_number"
                    v-else-if="
                      editCellData(scopeChildren.row, scopeChildren.column) ==
                      'inputNumber'
                    "
                    :controls="false"
                    :precision="columnSon.precision || 0"
                    :min="0"
                    :max="columnSon.max || 999999"
                    v-model="scopeChildren.row[columnSon.prop]"
                    :maxLength="6"
                    @blur="changeCellData()"
                    :ref="`input${scopeChildren.row.index}-${columnSon.prop}`"
                    @keyup.native.enter="
                      focusNextInput(scopeChildren.row.index, columnSon.prop)
                    "
                  />

                  <!-- <t-input-number
                    v-if="editCellData(scopeChildren.row, scopeChildren.column)"
                    class="cell_input_number"
                    :controls="false"
                    :precision="columnSon.precision || 0"
                    :min="0"
                    :max="columnSon.max || 999999"
                    v-model="scopeChildren.row[columnSon.prop]"
                    :maxLength="columnSon.maxLength"
                    @blur="changeCellData(columnSon.max)"
                  ></t-input-number> -->
                  <span v-else>
                    {{ scopeChildren.row[columnSon.prop] }}
                  </span>
                </template>
              </t-table-column>
            </template>
          </t-table-column>
        </t-table>
      </div>

      <!-- 合計 -->
      <div :style="{ height: bottomHeight + 'px' }">
        <t-row>
          <t-col :span="12">&nbsp;</t-col>
          <t-col :span="6" class="col_common_right"
            ><t-input
              v-model="setPriceAll"
              style="margin-top: 15px; margin-right: 20px"
              :disabled="true"
              class="sumInput"
            >
              <template slot="prepend">
                <span style="width: 110px" class="span_style">{{
                  $t("resource.NUMBER.SET_PRICE_ALL") +
                  $t("resource.NUMBER.CUR_TYPE")
                }}</span></template
              >
            </t-input></t-col
          >
          <t-col :span="6" class="col_common_right"
            ><t-input
              v-model="grossProfitAll"
              style="margin-top: 15px"
              :disabled="true"
              class="sumInput"
            >
              <template slot="prepend">
                <span style="width: 110px" class="span_style">{{
                  $t("resource.NUMBER.GROSS_PROFIT_ALL") +
                  $t("resource.NUMBER.CUR_TYPE")
                }}</span></template
              >
            </t-input></t-col
          >
        </t-row>
        <t-row>
          <t-col :span="24" class="right">
            <!-- 確定ボタン -->
            <t-button
              round
              type="warning"
              class="dialogButton_confirm_120_40"
              ref="confirmBtn"
              :disabled="productNotEditFlg"
              @click="confirmClick()"
            >
              <i class="el-icon-check"></i>
              {{ $t("resource.sys.sure") }}
            </t-button>
          </t-col>
        </t-row>
      </div>
    </t-card>
  </div>
</template>
<script>
import { getUserInfo } from "@/auth";
import {
  ShowEstimateInfoReferenceDialog,
  ShowRateReferenceDialog,
} from "@/components/Dialog";
import { t } from "@/locales";
import {
  editNumberInfoByCustomer, //---
  editNumberInfoEsimateAndCompany,
  EditQuoteStateByQuoteNo,
  searchNumberDetailCustomerByNbQuoteNo,
} from "@/services/number";
import {
  cmpDetailData,
  formatCurrencyToNumber,
  formatStringToCurrency,
  getDialogContentHeight,
  numberFormat,
} from "@/utils/comFunction";
import {
  DIALOG_LINE_HEIGHT,
  FACTORY_KBN_CPY,
  FACTORY_KBN_DALIAN,
  FACTORY_KBN_JAPAN,
  NB_PROC_KBN_TRUE,
  STR_EMPTY,
} from "@/utils/const";
//import { setColumnWidth } from "@/utils/table";
import { httpApi } from "@/api/api";
import { outputExcelToZip } from "@/services/common";
import { Message, Modal } from "@tellus/component";
export default {
  data() {
    return {
      //比較用明細情報
      cmpDetailResult: {},
      //読み込み回数
      numLoads: 1,

      //基本情報のheight
      basicHeight: DIALOG_LINE_HEIGHT * 1,
      //明細情報のheight
      detailHeight: getDialogContentHeight(
        window.innerHeight,
        DIALOG_LINE_HEIGHT * 1,
        DIALOG_LINE_HEIGHT * 2,
        10
      ),
      //合計情報のheight
      bottomHeight: DIALOG_LINE_HEIGHT * 2,

      //得意先見積のテーブル
      customerTable: [],
      //得意先見積のテーブルの列
      customerTableColumns: [
        {
          prop: "ndProdName",
          label: t("resource.COMMON_CONSTANT.PRODUCT_NAME"),
          width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_FIFTY"),
          class: "cell_txt_left",
          fixed: true,
          overflowTooltip: true,
        },
        {
          prop: "ndProdDrawNo",
          label: t("resource.COMMON_CONSTANT.PICTURE_NO"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          fixed: true,
          overflowTooltip: true,
        },
        {
          prop: "ndProdQuantity",
          label: t("resource.COMMON_CONSTANT.COUNT"),
          width: t("widgetSize.tableCommon.width50"),
          class: "cell_txt_right",
          fixed: true,
        },
        {
          prop: "ndProdUnit",
          label: t("resource.COMMON_CONSTANT.UNIT"),
          width: t("widgetSize.tableCommon.width50"),
          class: "cell_txt_center",
          fixed: true,
          overflowTooltip: true,
        },

        {
          label: t("resource.NUMBER.PRODUCT_INFO"),
          children: [
            {
              prop: "ndProdShape",
              label: t("resource.COMMON_CONSTANT.SHAPE"),
              width: t("widgetSize.tableCommon.defaultWidth"),
              class: "cell_txt_center",
              maxLength: 10,
              overflowTooltip: true,
            },
            {
              prop: "ndProdMaterial",
              label: t("resource.COMMON_CONSTANT.MATERIAL"),
              width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_FIFTY"),
              class: "cell_txt_left",
              overflowTooltip: true,
            },
            {
              prop: "ndProdTreatment",
              label: t("resource.COMMON_CONSTANT.TREATMENT"),
              width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_FIFTY"),
              class: "cell_txt_left",
              overflowTooltip: true,
            },
            {
              prop: "ndUWeight",
              label: t("resource.NUMBER.U_WEIGHT"),
              width: t("widgetSize.tableCommon.defaultWidth"),
              precision: 3,
              max: 99999.999,
              class: "cell_txt_right",
            },
          ],
        },

        // {
        //   label: t("resource.NUMBER.PRODUCT_INFO"),
        //   children: [
        //     {
        //       prop: "ndProdName",
        //       label: t("resource.COMMON_CONSTANT.PRODUCT_NAME"),
        //       width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_FIFTY"),
        //       class: "cell_txt_left",
        //       overflowTooltip: true,
        //     },
        //     {
        //       prop: "ndProdDrawNo",
        //       label: t("resource.COMMON_CONSTANT.PICTURE_NO"),
        //       width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_FIFTY"),
        //       class: "cell_txt_left",
        //       overflowTooltip: true,
        //     },
        //     {
        //       prop: "ndProdQuantity",
        //       label: t("resource.COMMON_CONSTANT.COUNT"),
        //       width: t("widgetSize.tableCommon.defaultWidth"),
        //       class: "cell_txt_right",
        //     },
        //     {
        //       prop: "ndProdUnit",
        //       label: t("resource.COMMON_CONSTANT.UNIT"),
        //       width: t("widgetSize.tableCommon.defaultWidth"),
        //       class: "cell_txt_center",
        //       overflowTooltip: true,
        //     },
        //     {
        //       prop: "ndProdShape",
        //       label: t("resource.COMMON_CONSTANT.SHAPE"),
        //       width: t("widgetSize.tableCommon.defaultWidth"),
        //       class: "cell_txt_center",
        //       maxLength: 10,
        //       overflowTooltip: true,
        //     },
        //     {
        //       prop: "ndProdMaterial",
        //       label: t("resource.COMMON_CONSTANT.MATERIAL"),
        //       width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_FIFTY"),
        //       class: "cell_txt_left",
        //       overflowTooltip: true,
        //     },
        //     {
        //       prop: "ndProdTreatment",
        //       label: t("resource.COMMON_CONSTANT.TREATMENT"),
        //       width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_FIFTY"),
        //       class: "cell_txt_left",
        //       overflowTooltip: true,
        //     },
        //     {
        //       prop: "ndUWeight",
        //       label: t("resource.NUMBER.U_WEIGHT"),
        //       width: t("widgetSize.tableCommon.defaultWidth"),
        //       precision: 3,
        //       max: 99999.999,
        //       class: "cell_txt_right",
        //     },
        //   ],
        // },
        {
          label:
            t("resource.NUMBER.MAIN_PROCESSING") +
            t("resource.NUMBER.CUR_TYPE"),
          children: [
            {
              prop: "ndMSupCode",
              label: t("resource.COMMON_CONSTANT.SUPPLIER"),
              width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_EIGHTY"),
              class: "cell_txt_left",
              overflowTooltip: true,
            },
            {
              prop: "ndMSupFactoryKbnStr",
              label: t("resource.NUMBER.SUP_FACTORY_KBN"),
              width: t("widgetSize.tableCommon.defaultWidth"),
              class: "cell_txt_left",
            },
            {
              prop: "ndMUPrice",
              label: t("resource.NUMBER.U_PRICE"),
              width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_FIFTY"),
              class: "cell_txt_right",
              overflowTooltip: true,
              maxLength: 6,
            },
            // {
            //   prop: "ndMTransportCost",
            //   label: t("resource.NUMBER.TRANSPORT_COST"),
            //   width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_FIFTY"),
            //   class: "cell_txt_right",
            //   overflowTooltip: true,
            //   maxLength: 6,
            // },
            {
              prop: "ndMUTransportCostCny",
              label: t("resource.NUMBER.U_TRANSPORT_COST"),
              width: t("widgetSize.tableCommon.defaultWidth"),
              class: "cell_txt_right",
            },
            {
              prop: "ndMCommissionRate",
              label: t("resource.NUMBER.COMMISSION_RATE"),
              width: t("widgetSize.tableCommon.defaultWidth"),
              class: "cell_txt_right",
              maxLength: 5,
              precision: 2,
              max: 99.99,
            },
            // {
            //   prop: "ndMUCommission",
            //   label: t("resource.NUMBER.U_COMMISSION"),
            //   width: t("widgetSize.tableCommon.defaultWidth"),
            //   class: "cell_txt_right",
            // },
            {
              prop: "ndMUPurchasePrice",
              label: t("resource.NUMBER.U_PURCHASE_PRICE"),
              width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_FIFTY"),
              class: "cell_txt_right",
              overflowTooltip: true,
            },
          ],
        },
        {
          label:
            t("resource.NUMBER.PROCESSING_ONE") + t("resource.NUMBER.CUR_TYPE"),
          isShow: true,
          children: [
            {
              prop: "ndP1SupCode",
              label: t("resource.COMMON_CONSTANT.SUPPLIER"),
              width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_EIGHTY"),
              class: "cell_txt_left",
              overflowTooltip: true,
            },
            {
              prop: "ndP1SupFactoryKbnStr",
              label: t("resource.NUMBER.SUP_FACTORY_KBN"),
              width: t("widgetSize.tableCommon.defaultWidth"),
              class: "cell_txt_left",
            },
            {
              prop: "ndP1UPrice",
              label: t("resource.NUMBER.U_PRICE"),
              width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_FIFTY"),
              class: "cell_txt_right",
              overflowTooltip: true,
              maxLength: 6,
            },
            {
              prop: "ndP1TransportCost",
              label: t("resource.NUMBER.TRANSPORT_COST"),
              width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_FIFTY"),
              class: "cell_txt_right",
              overflowTooltip: true,
              maxLength: 6,
            },
            // {
            //   prop: "ndP1UTransportCost",
            //   label: t("resource.NUMBER.U_TRANSPORT_COST"),
            //   width: t("widgetSize.tableCommon.defaultWidth"),
            //   class: "cell_txt_right",
            // },
            {
              prop: "ndP1CommissionRate",
              label: t("resource.NUMBER.COMMISSION_RATE"),
              width: t("widgetSize.tableCommon.defaultWidth"),
              class: "cell_txt_right",
              maxLength: 5,
              precision: 2,
              max: 99.99,
            },
            // {
            //   prop: "ndP1UCommission",
            //   label: t("resource.NUMBER.U_COMMISSION"),
            //   width: t("widgetSize.tableCommon.defaultWidth"),
            //   class: "cell_txt_right",
            // },
            {
              prop: "ndP1UPurchasePrice",
              label: t("resource.NUMBER.U_PURCHASE_PRICE"),
              width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_FIFTY"),
              class: "cell_txt_right",
              overflowTooltip: true,
            },
          ],
        },
        {
          label:
            t("resource.NUMBER.PROCESSING_TWO") + t("resource.NUMBER.CUR_TYPE"),
          isShow: true,
          children: [
            {
              prop: "ndP2SupCode",
              label: t("resource.COMMON_CONSTANT.SUPPLIER"),
              width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_EIGHTY"),
              class: "cell_txt_left",
              overflowTooltip: true,
            },
            {
              prop: "ndP2SupFactoryKbnStr",
              label: t("resource.NUMBER.SUP_FACTORY_KBN"),
              width: t("widgetSize.tableCommon.defaultWidth"),
              class: "cell_txt_left",
            },
            {
              prop: "ndP2UPrice",
              label: t("resource.NUMBER.U_PRICE"),
              width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_FIFTY"),
              class: "cell_txt_right",
              overflowTooltip: true,
              maxLength: 6,
            },
            {
              prop: "ndP2TransportCost",
              label: t("resource.NUMBER.TRANSPORT_COST"),
              width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_FIFTY"),
              class: "cell_txt_right",
              overflowTooltip: true,
              maxLength: 6,
            },
            // {
            //   prop: "ndP2UTransportCost",
            //   label: t("resource.NUMBER.U_TRANSPORT_COST"),
            //   width: t("widgetSize.tableCommon.defaultWidth"),
            //   class: "cell_txt_right",
            // },
            {
              prop: "ndP2CommissionRate",
              label: t("resource.NUMBER.COMMISSION_RATE"),
              width: t("widgetSize.tableCommon.defaultWidth"),
              class: "cell_txt_right",
              maxLength: 5,
              precision: 2,
              max: 99.99,
            },
            // {
            //   prop: "ndP2UCommission",
            //   label: t("resource.NUMBER.U_COMMISSION"),
            //   width: t("widgetSize.tableCommon.defaultWidth"),
            //   class: "cell_txt_right",
            // },
            {
              prop: "ndP2UPurchasePrice",
              label: t("resource.NUMBER.U_PURCHASE_PRICE"),
              width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_FIFTY"),
              class: "cell_txt_right",
              overflowTooltip: true,
            },
          ],
        },
        {
          label:
            t("resource.NUMBER.PROCESSING_THREE") +
            t("resource.NUMBER.CUR_TYPE"),
          isShow: true,
          children: [
            {
              prop: "ndP3SupCode",
              label: t("resource.COMMON_CONSTANT.SUPPLIER"),
              width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_EIGHTY"),
              class: "cell_txt_left",
              overflowTooltip: true,
            },
            {
              prop: "ndP3SupFactoryKbnStr",
              label: t("resource.NUMBER.SUP_FACTORY_KBN"),
              width: t("widgetSize.tableCommon.defaultWidth"),
              class: "cell_txt_left",
            },
            {
              prop: "ndP3UPrice",
              label: t("resource.NUMBER.U_PRICE"),
              width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_FIFTY"),
              class: "cell_txt_right",
              overflowTooltip: true,
              maxLength: 6,
            },
            {
              prop: "ndP3TransportCost",
              label: t("resource.NUMBER.TRANSPORT_COST"),
              width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_FIFTY"),
              class: "cell_txt_right",
              overflowTooltip: true,
              maxLength: 6,
            },
            // {
            //   prop: "ndP3UTransportCost",
            //   label: t("resource.NUMBER.U_TRANSPORT_COST"),
            //   width: t("widgetSize.tableCommon.defaultWidth"),
            //   class: "cell_txt_right",
            // },
            {
              prop: "ndP3CommissionRate",
              label: t("resource.NUMBER.COMMISSION_RATE"),
              width: t("widgetSize.tableCommon.defaultWidth"),
              class: "cell_txt_right",
              maxLength: 5,
              precision: 2,
              max: 99.99,
            },
            // {
            //   prop: "ndP3UCommission",
            //   label: t("resource.NUMBER.U_COMMISSION"),
            //   width: t("widgetSize.tableCommon.defaultWidth"),
            //   class: "cell_txt_right",
            // },
            {
              prop: "ndP3UPurchasePrice",
              label: t("resource.NUMBER.U_PURCHASE_PRICE"),
              width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_FIFTY"),
              class: "cell_txt_right",
              overflowTooltip: true,
            },
          ],
        },
        {
          label: t("resource.NUMBER.QUOTE_INFO"),
          children: [
            {
              prop: "ndSumPurchasePrice",
              label: t("resource.NUMBER.SUM_PURCHASE_PRICE"),
              width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_FIFTY"),
              overflowTooltip: true,
              class: "cell_txt_right",
            },
            {
              prop: "ndGrossMargin",
              label: t("resource.NUMBER.GROSS_MARGIN"),
              width: t("widgetSize.tableCommon.defaultWidth"),
              class: "cell_txt_right",
              maxLength: 5,
              precision: 2,
              max: 99.99,
            },
            {
              prop: "ndUSalesPrice",
              label: t("resource.NUMBER.U_SALES_PRICE"),
              width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_FIFTY"),
              overflowTooltip: true,
              class: "cell_txt_right",
            },
            {
              prop: "ndUSetPrice",
              label: t("resource.NUMBER.U_SET_PRICE"),
              width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_FIFTY"),
              class: "cell_txt_right",
              maxLength: 6,
              overflowTooltip: true,
            },
            {
              prop: "ndUGrossProfit",
              label: t("resource.NUMBER.U_GROSS_PROFIT"),
              width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_FIFTY"),
              overflowTooltip: true,
              class: "cell_txt_right",
              maxLength: 6,
            },
            {
              prop: "ndTotPurchasePrice",
              label: t("resource.NUMBER.TOT_PURCHASE_PRICE"),
              width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_FIFTY"),
              overflowTooltip: true,
              class: "cell_txt_right",
            },
            {
              prop: "ndTotSalesPrice",
              label: t("resource.NUMBER.TOT_SALES_PRICE"),
              width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_FIFTY"),
              overflowTooltip: true,
              class: "cell_txt_right",
            },
            {
              prop: "ndTotGrossProfit",
              label: t("resource.NUMBER.TOT_GROSS_PROFIT"),
              width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_FIFTY"),
              overflowTooltip: true,
              class: "cell_txt_right",
            },
            {
              prop: "ndTotWeight",
              label: t("resource.NUMBER.TOT_WEIGHT"),
              width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_FIFTY"),
              overflowTooltip: true,
              class: "cell_txt_right",
            },
          ],
        },
      ],

      //データの更新時刻
      nbUpdateTime: null,

      //処理1
      P1Show: false,
      //処理2
      P2Show: false,
      //処理3
      P3Show: false,

      //見積No.
      localNbQuoteNo: this.nbQuoteNo,

      //確定売価合計
      setPriceAll: 0,
      //粗利合計
      grossProfitAll: 0,

      //ドル(USD)⇒円(JPY)
      USDToJPY: 0,
      //元(CNY)⇒円(JPY)
      CNYToJPY: 0,
      //バーツ(THB)⇒円(JPY)
      THBToJPY: 0,
      //円(JPY)⇒円(JPY)
      JPYToJPY: 1,

      //カバー層のフラップ false:表示しない
      showFlag: false,
    };
  },

  props: {
    nbQuoteNo: {
      Type: String,
    },
    nbProcKbn: {
      Type: String,
    },
    nbQuoteDate: {
      Type: String,
    },
    productNotEditFlg: {
      Type: Boolean,
    },
  },
  computed: {
    filteredColumns() {
      return this.customerTableColumns.filter((column) => {
        if (
          column.label ==
          t("resource.NUMBER.PROCESSING_ONE") + t("resource.NUMBER.CUR_TYPE")
        ) {
          return this.P1Show;
        }
        if (
          column.label ==
          t("resource.NUMBER.PROCESSING_TWO") + t("resource.NUMBER.CUR_TYPE")
        ) {
          return this.P2Show;
        }
        if (
          column.label ==
          t("resource.NUMBER.PROCESSING_THREE") + t("resource.NUMBER.CUR_TYPE")
        ) {
          return this.P3Show;
        }
        return true; // 他の列は常に表示されます
      });
    },
  },

  mounted() {
    this.init();
    //テーブルの高さを監視する
    window.addEventListener("resize", this.handleResize);
  },

  methods: {
    // 初期化
    init() {
      this.showFlag = true;
      this.setInitValue();
      this.searchNumberDetailCustomerByNbQuoteNoProc();
      this.handleResize();
    },

    //初期値の設定
    setInitValue() {
      this.P1Show =
        this.nbProcKbn.split("")[1] == NB_PROC_KBN_TRUE ? true : false;
      this.P2Show =
        this.nbProcKbn.split("")[2] == NB_PROC_KBN_TRUE ? true : false;
      this.P3Show =
        this.nbProcKbn.split("")[3] == NB_PROC_KBN_TRUE ? true : false;
    },

    //検索
    searchNumberDetailCustomerByNbQuoteNoProc() {
      //見積No.による採番詳細情報の取得
      searchNumberDetailCustomerByNbQuoteNo({
        nbQuoteNo: this.localNbQuoteNo,
      })
        .then((res) => {
          this.nbUpdateTime = res.nbUpdateTime;
          this.customerTable = res.customerTable;

          this.dataProcess();
          // setColumnWidth(this.filteredColumns, this.customerTable);
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(
              t("message.COMMON_MESSAGE.DETAIL_SEARCH_FAILURE")
            );
          }
        })
        .finally(() => {
          this.showFlag = false;
        });
    },

    //テーブルの高さを設定する
    handleResize() {
      this.detailHeight = getDialogContentHeight(
        window.innerHeight,
        DIALOG_LINE_HEIGHT * 1,
        DIALOG_LINE_HEIGHT * 2,
        10
      );
    },

    //データの処理
    dataProcess() {
      this.customerTable.map((item) => {
        //重量(kg/个)
        if (
          item.ndUWeight == undefined ||
          item.ndUWeight == STR_EMPTY ||
          isNaN(item.ndUWeight)
        ) {
          //item.ndUWeight = 0.0;
          item.ndUWeight = undefined;
        }

        //加工_レート
        if (!item.ndMExr || item.ndMExr == 0) {
          item.ndMExr = 1;
        }

        //加工_加工単価(JPY)
        if (
          isNaN(formatCurrencyToNumber(item.ndMUPrice)) ||
          formatCurrencyToNumber(item.ndMUPrice) <= 0
        ) {
          //item.ndMUPrice = "0";
          item.ndMUPrice = STR_EMPTY;
        } else {
          //最新のレートを取得した場合、加工単価を再計算する
          item.ndMUPrice = formatStringToCurrency(
            (formatCurrencyToNumber(item.ndMUPrice) / item.ndMExr) *
              (this.getRateByCurType(item.ndMExr, item.ndMCurType) == 0
                ? item.ndMExr
                : this.getRateByCurType(item.ndMExr, item.ndMCurType))
          );
        }

        //加工_レート(最新のレート)
        if (item.ndMExr != undefined && item.ndMExr != 0) {
          if (
            this.getRateByCurType(item.ndMExr, item.ndMCurType) != 0 &&
            this.getRateByCurType(item.ndMExr, item.ndMCurType) != item.ndMExr
          ) {
            item.ndMExr = this.getRateByCurType(item.ndMExr, item.ndMCurType);
          }
        }

        //大連工場の場合、加工_加工単価(CNY)＝加工_加工単価(JPY)/加工_レート
        if (item.ndMSupFactoryKbn == FACTORY_KBN_DALIAN) {
          item.ndMUPriceCny = formatStringToCurrency(
            formatCurrencyToNumber(item.ndMUPrice) / item.ndMExr
          );
        }
        //加工_運賃（JPY/kg）
        // item.ndMTransportCost =
        //   item.ndMSupFactoryKbn == FACTORY_KBN_DALIAN
        //     ? isNaN(formatCurrencyToNumber(item.ndMTransportCost))
        //       ? STR_EMPTY //"0"
        //       : formatStringToCurrency(item.ndMTransportCost)
        //     : STR_EMPTY; //"0";

        //加工_運賃（元/个）
        item.ndMUTransportCostCny =
          item.ndMSupFactoryKbn == FACTORY_KBN_DALIAN
            ? isNaN(
                this.calNdMUTransportCostCny(
                  formatCurrencyToNumber(item.ndMUPrice),
                  item.ndMExr,
                  formatCurrencyToNumber(item.ndUWeight)
                )
              )
              ? "0"
              : this.calNdMUTransportCostCny(
                  formatCurrencyToNumber(item.ndMUPrice),
                  item.ndMExr,
                  formatCurrencyToNumber(item.ndUWeight)
                )
            : "0";

        //加工_運賃（JPY/个）
        item.ndMUTransportCost =
          item.ndMSupFactoryKbn == FACTORY_KBN_DALIAN
            ? isNaN(
                formatCurrencyToNumber(item.ndMUTransportCostCny) * item.ndMExr
              )
              ? "0"
              : formatStringToCurrency(
                  formatCurrencyToNumber(item.ndMUTransportCostCny) *
                    item.ndMExr
                )
            : "0";

        //加工_提成率（%）
        if (
          item.ndMCommissionRate == undefined ||
          item.ndMCommissionRate == STR_EMPTY ||
          isNaN(item.ndMCommissionRate)
        ) {
          item.ndMCommissionRate =
            item.ndMSupFactoryKbn == FACTORY_KBN_DALIAN ? undefined : 0;
        } else {
          item.ndMCommissionRate =
            item.ndMSupFactoryKbn == FACTORY_KBN_DALIAN
              ? isNaN(formatCurrencyToNumber(item.ndMCommissionRate))
                ? undefined //0
                : formatCurrencyToNumber(item.ndMCommissionRate)
              : 0;

          if (item.ndMSupFactoryKbn == FACTORY_KBN_DALIAN) {
            if (item.ndMCommissionRate > 99.99) {
              item.ndMCommissionRate = 99.99;
            } else if (item.ndMCommissionRate < 0) {
              item.ndMCommissionRate = undefined; //0;
            } else {
              item.ndMCommissionRate = item.ndMCommissionRate;
            }
          } else {
            item.ndMCommissionRate = undefined; //0;
          }
        }

        //加工_仕入価格(JPY/個=加工_加工単価(JPY) + 加工_運賃(JPY) + 加工_提成(JPY/個)
        item.ndMUPurchasePrice = formatStringToCurrency(
          formatCurrencyToNumber(item.ndMUPrice) +
            formatCurrencyToNumber(item.ndMUTransportCost) +
            formatCurrencyToNumber(item.ndMUPrice) *
              formatCurrencyToNumber(item.ndMCommissionRate) *
              0.01
        );

        if (!this.isEmptyOrNull(item.ndP1SupCode)) {
          //処理1_レート
          if (!item.ndP1Exr || item.ndP1Exr == 0) {
            item.ndP1Exr = 1;
          }

          //処理1_加工単価(JPY)
          if (
            isNaN(formatCurrencyToNumber(item.ndP1UPrice)) ||
            formatCurrencyToNumber(item.ndP1UPrice) <= 0
          ) {
            item.ndP1UPrice = STR_EMPTY; //"0";
          } else {
            //最新のレートを取得した場合、加工単価を再計算する
            item.ndP1UPrice = formatStringToCurrency(
              (formatCurrencyToNumber(item.ndP1UPrice) / item.ndP1Exr) *
                (this.getRateByCurType(item.ndP1Exr, item.ndP1CurType) == 0
                  ? item.ndP1Exr
                  : this.getRateByCurType(item.ndP1Exr, item.ndP1CurType))
            );
          }

          //処理1_レート(最新のレート)
          if (item.ndP1Exr != undefined && item.ndP1Exr != 0) {
            if (
              this.getRateByCurType(item.ndP1Exr, item.ndP1CurType) != 0 &&
              this.getRateByCurType(item.ndP1Exr, item.ndP1CurType) !=
                item.ndP1Exr
            ) {
              item.ndP1Exr = this.getRateByCurType(
                item.ndP1Exr,
                item.ndP1CurType
              );
            }
          }
          //処理1_運賃（JPY/kg）
          item.ndP1TransportCost = 0;

          //処理1_提成率（%）
          item.ndP1CommissionRate = 0;

          //処理1_仕入価格(JPY/個）=処理1_加工単価(JPY) + 処理1_運賃(JPY/個) + 処理1_提成(JPY/個)
          item.ndP1UPurchasePrice = formatStringToCurrency(
            formatCurrencyToNumber(item.ndP1UPrice)
          );
        } else {
          //処理1_工場
          item.ndP1SupFactoryKbn = STR_EMPTY;
          //処理1_加工単価(JPY)
          item.ndP1UPrice = STR_EMPTY;
          //処理1_運賃（JPY/kg）
          item.ndP1TransportCost = STR_EMPTY;
          //処理1_提成率（%）
          item.ndP1CommissionRate = STR_EMPTY;
          //処理1_仕入価格(JPY/個=処理1_加工単価(JPY) + 処理1_運賃(JPY/個) + 処理1_提成(JPY/個)
          item.ndP1UPurchasePrice = STR_EMPTY;
        }

        if (!this.isEmptyOrNull(item.ndP2SupCode)) {
          //処理2_レート
          if (!item.ndP2Exr || item.ndP2Exr == 0) {
            item.ndP2Exr = 1;
          }

          //処理2_加工単価(JPY)
          if (
            isNaN(formatCurrencyToNumber(item.ndP2UPrice)) ||
            formatCurrencyToNumber(item.ndP2UPrice) <= 0
          ) {
            item.ndP2UPrice = STR_EMPTY; //"0";
          } else {
            //最新のレートを取得した場合、加工単価を再計算する
            item.ndP2UPrice = formatStringToCurrency(
              (formatCurrencyToNumber(item.ndP2UPrice) / item.ndP2Exr) *
                (this.getRateByCurType(item.ndP2Exr, item.ndP2CurType) == 0
                  ? item.ndP2Exr
                  : this.getRateByCurType(item.ndP2Exr, item.ndP2CurType))
            );
          }

          //処理2_レート(最新のレート)
          if ((item.ndP2Exr != undefined) & (item.ndP2Exr != 0)) {
            if (
              this.getRateByCurType(item.ndP2Exr, item.ndP2CurType) != 0 &&
              this.getRateByCurType(item.ndP2Exr, item.ndP2CurType) !=
                item.ndP2Exr
            ) {
              item.ndP2Exr = this.getRateByCurType(
                item.ndP2Exr,
                item.ndP2CurType
              );
            }
          }

          //処理2_運賃（JPY/kg）
          item.ndP2TransportCost = 0;

          //処理2_提成率（%）
          item.ndP2CommissionRate = 0;

          //処理2_仕入価格(JPY/個=処理2_加工単価(JPY) + 処理2_運賃(JPY/個) + 処理2_提成(JPY/個)
          item.ndP2UPurchasePrice = formatStringToCurrency(
            formatCurrencyToNumber(item.ndP2UPrice)
          );
        } else {
          //処理2_工場
          item.ndP2SupFactoryKbn = STR_EMPTY;
          //処理2_加工単価(JPY)
          item.ndP2UPrice = STR_EMPTY;
          //処理2_運賃（JPY/kg）
          item.ndP2TransportCost = STR_EMPTY;
          //処理2_提成率（%）
          item.ndP2CommissionRate = STR_EMPTY;
          //処理2_仕入価格(JPY/個=処理2_加工単価(JPY) + 処理2_運賃(JPY/個) + 処理2_提成(JPY/個)
          item.ndP2UPurchasePrice = STR_EMPTY;
        }

        if (!this.isEmptyOrNull(item.ndP3SupCode)) {
          //処理3_レート
          if (!item.ndP3Exr || item.ndP3Exr == 0) {
            item.ndP3Exr = 1;
          }

          //処理3_加工単価(JPY)
          if (
            isNaN(formatCurrencyToNumber(item.ndP3UPrice)) ||
            formatCurrencyToNumber(item.ndP3UPrice) <= 0
          ) {
            item.ndP3UPrice = STR_EMPTY; //"0";
          } else {
            //最新のレートを取得した場合、加工単価を再計算する
            item.ndP3UPrice = formatStringToCurrency(
              (formatCurrencyToNumber(item.ndP3UPrice) / item.ndP3Exr) *
                (this.getRateByCurType(item.ndP3Exr, item.ndP3CurType) == 0
                  ? item.ndP3Exr
                  : this.getRateByCurType(item.ndP3Exr, item.ndP3CurType))
            );
          }

          //処理3_レート(最新のレート)
          if (item.ndP3Exr != undefined && item.ndP3Exr != 0) {
            if (
              this.getRateByCurType(item.ndP3Exr, item.ndP3CurType) != 0 &&
              this.getRateByCurType(item.ndP3Exr, item.ndP3CurType) !=
                item.ndP3Exr
            ) {
              item.ndP3Exr = this.getRateByCurType(
                item.ndP3Exr,
                item.ndP3CurType
              );
            }
          }

          //処理3_運賃（JPY/kg）
          item.ndP3TransportCost = 0;

          //処理3_提成率（%）
          item.ndP3CommissionRate = 0;

          //処理3_仕入価格(JPY/個=処理3_加工単価(JPY) + 処理3_運賃(JPY/個) + 処理3_提成(JPY/個)
          item.ndP3UPurchasePrice = formatStringToCurrency(
            formatCurrencyToNumber(item.ndP3UPrice)
          );
        } else {
          //処理3_工場
          item.ndP3SupFactoryKbn = STR_EMPTY;
          //処理3_加工単価(JPY)
          item.ndP3UPrice = STR_EMPTY;
          //処理3_運賃（JPY/kg）
          item.ndP3TransportCost = STR_EMPTY;
          //処理3_提成率（%）
          item.ndP3CommissionRate = STR_EMPTY;
          //処理3_仕入価格(JPY/個=処理3_加工単価(JPY) + 処理3_運賃(JPY/個) + 処理3_提成(JPY/個)
          item.ndP3UPurchasePrice = STR_EMPTY;
        }

        //仕入価格小計=加工_仕入価格(JPY/個) + 処理1_仕入価格(JPY/個) + 処理2_仕入価格(JPY/個) + 処理3_仕入価格(JPY/個)
        item.ndSumPurchasePrice = formatStringToCurrency(
          formatCurrencyToNumber(item.ndMUPurchasePrice) +
            formatCurrencyToNumber(item.ndP1UPurchasePrice) +
            formatCurrencyToNumber(item.ndP2UPurchasePrice) +
            formatCurrencyToNumber(item.ndP3UPurchasePrice)
        );

        //粗利率(%)
        if (
          item.ndGrossMargin == undefined ||
          item.ndGrossMargin == STR_EMPTY ||
          isNaN(item.ndGrossMargin)
        ) {
          item.ndGrossMargin = undefined; //0;
        } else {
          item.ndGrossMargin = item.ndGrossMargin;
        }

        //売価（JPY/個） = 仕入価格小計 / （1‐粗利率(%)）
        item.ndUSalesPrice = formatStringToCurrency(
          formatCurrencyToNumber(item.ndSumPurchasePrice) /
            (1 - item.ndGrossMargin * 0.01),
          "0"
        );

        //確定売価(JPY/個)
        item.ndUSetPrice =
          formatStringToCurrency(item.ndUSetPrice) == "0"
            ? STR_EMPTY
            : formatStringToCurrency(item.ndUSetPrice);

        //粗利(JPY/個) =  確定売価（JPY/個）- 仕入価格小計
        item.ndUGrossProfit = formatStringToCurrency(
          formatCurrencyToNumber(item.ndUSetPrice) -
            formatCurrencyToNumber(item.ndSumPurchasePrice)
        );

        //小計仕入金額(JPY)=仕入価格小計 * 数量
        item.ndTotPurchasePrice = formatStringToCurrency(
          formatCurrencyToNumber(item.ndSumPurchasePrice) *
            formatCurrencyToNumber(item.ndProdQuantity)
        );

        //小計売上金額(JPY)=確定売価（JPY/個） * 数量
        item.ndTotSalesPrice = formatStringToCurrency(
          formatCurrencyToNumber(item.ndUSetPrice) *
            formatCurrencyToNumber(item.ndProdQuantity)
        );

        //小計粗利(JPY)=小計売上金額（JPY）- 小計仕入金額（JPY）
        item.ndTotGrossProfit = formatStringToCurrency(
          formatCurrencyToNumber(item.ndTotSalesPrice) -
            formatCurrencyToNumber(item.ndTotPurchasePrice)
        );

        //小計重量(kg)=重量（kg/個） * 数量
        item.ndTotWeight = numberFormat(
          item.ndProdQuantity * item.ndUWeight,
          "0.000"
        );

        return item;
      });

      //売上合計
      var setPriceAllTmp = 0;
      this.customerTable.forEach((row) => {
        setPriceAllTmp += formatCurrencyToNumber(row.ndTotSalesPrice);
      });
      this.setPriceAll = formatStringToCurrency(setPriceAllTmp);

      //粗利合計
      var grossProfitAllTmp = 0;
      this.customerTable.forEach((row) => {
        grossProfitAllTmp += formatCurrencyToNumber(row.ndTotGrossProfit);
      });
      this.grossProfitAll = formatStringToCurrency(grossProfitAllTmp);

      //読み込み回数=1
      if (this.numLoads == 1) {
        //比較用詳細情報
        this.cmpDetailResult = JSON.parse(
          JSON.stringify(this.extract(this.customerTable))
        );

        this.numLoads = this.numLoads + 1;
      }
    },

    //セルの編集
    editCellData(row, column, cell, event) {
      //受注済みの場合、編集不可
      if (this.productNotEditFlg) {
        return false;
      }

      //編集可能な列:
      //「重量(kg/个)」
      //「加工_加工単価(JPY)」「加工_運賃（JPY/kg）」「加工_提成率（%）」
      //「処理1_加工単価(JPY)」「処理2_加工単価(JPY)」「処理3_加工単価(JPY)」
      //「粗利率(%)」「確定売価(JPY/個)」
      var columnEditable = [
        "ndUWeight",
        "ndMUPrice",
        //"ndMTransportCost",
        "ndMCommissionRate",
        "ndP1UPrice",
        "ndP2UPrice",
        "ndP3UPrice",
        "ndGrossMargin",
        "ndUSetPrice",
      ];

      //日本/本社工場の場合、運賃と提成率が編集不可
      if (
        row.ndMSupFactoryKbn &&
        (row.ndMSupFactoryKbn == FACTORY_KBN_JAPAN ||
          row.ndMSupFactoryKbn == FACTORY_KBN_CPY)
      ) {
        columnEditable = columnEditable.filter(
          (item) => item !== "ndMTransportCost" && item !== "ndMCommissionRate"
        );
      }

      //仕入先が空の場合、加工単価が編集不可
      if (this.isEmptyOrNull(row.ndP1SupCode)) {
        columnEditable = columnEditable.filter((item) => item !== "ndP1UPrice");
      }
      if (this.isEmptyOrNull(row.ndP2SupCode)) {
        columnEditable = columnEditable.filter((item) => item !== "ndP2UPrice");
      }
      if (this.isEmptyOrNull(row.ndP3SupCode)) {
        columnEditable = columnEditable.filter((item) => item !== "ndP3UPrice");
      }

      if (!columnEditable.includes(column.property)) {
        return false;
      }

      if (
        column.property == "ndMUPrice" ||
        column.property == "ndMTransportCost" ||
        column.property == "ndP1UPrice" ||
        column.property == "ndP2UPrice" ||
        column.property == "ndP3UPrice" ||
        column.property == "ndUSetPrice"
      ) {
        return "input";
      } else if (
        column.property == "ndMCommissionRate" ||
        column.property == "ndUWeight" ||
        column.property == "ndGrossMargin"
      ) {
        return "inputNumber";
      } else {
        return false;
      }
    },

    //セルの保存
    changeCellData() {
      this.dataProcess();

      //setColumnWidth(this.filteredColumns, this.customerTable);
    },

    //セルデータの数字変換
    changeCellDataToNumber(curRow, columnName) {
      curRow[columnName] = formatCurrencyToNumber(curRow[columnName]);
    },

    //確定ボタン
    confirmClick() {
      //入力チェック
      if (this.inputCheck()) {
        this.editNumberInfoByCustomerProc();
      }

      // フォーカス削除
      this.$refs.confirmBtn.$el.blur();
    },

    //入力チェック
    inputCheck() {
      //製品情報はデータがある場合
      if (this.customerTable.length > 0) {
        for (var index = 0; index < this.customerTable.length; index++) {
          const row = this.customerTable[index];

          //重量の入力チェック:加工_加工単価(CNY)>1000の場合、重量は有効値である
          if (
            row.ndMSupFactoryKbn == FACTORY_KBN_DALIAN &&
            formatCurrencyToNumber(row.ndMUPrice) > 1000 * row.ndMExr &&
            formatCurrencyToNumber(row.ndUWeight) == 0
          ) {
            Modal.showWarning(
              "",
              t("message.NUMBER.NULL_VALUE")
                .replace("{0}", row.ndProdName)
                .replace("{1}", t("resource.NUMBER.U_WEIGHT"))
                .replace("{2}", t("resource.NUMBER.PRODUCT_INFO")),
              {
                confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
              }
            );
            return false;
          }

          if (formatCurrencyToNumber(row.ndUSetPrice) == 0) {
            Modal.showWarning(
              "",
              t("message.NUMBER.NULL_VALUE")
                .replace("{0}", row.ndProdName)
                .replace("{1}", t("resource.NUMBER.U_SET_PRICE"))
                .replace("{2}", t("resource.NUMBER.QUOTE_INFO")),
              {
                confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
              }
            );
            return false;
          }
        }
      }
      return true;
    },

    //更新
    editNumberInfoByCustomerProc() {
      editNumberInfoByCustomer({
        nbQuoteNo: this.localNbQuoteNo,
        customerTable: this.customerTable,
        user: getUserInfo().UserId,
        nbUpdateTime: this.nbUpdateTime,
      })
        .then((res) => {
          Message.showSuccess(t("message.COMMON_MESSAGE.UPDATE_SUCCESS"));
          this.numLoads = 1;
          this.searchNumberDetailCustomerByNbQuoteNoProc();
        })
        .catch((err) => {
          this.showFlag = false;
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.UPDATE_FAILURE"));
          }
        });
    },

    //レート参照ボタン
    rateReferenceClick() {
      ShowRateReferenceDialog(
        {
          nbQuoteNo: this.nbQuoteNo,
          productNotEditFlg: this.productNotEditFlg,
        },
        t("resource.NUMBER.RATE_REFERENCE_VIEW"),
        (target) => {
          if (target != null) {
            //[USDToJPY;CNYToJPY;THBToJPY;JPY]
            this.USDToJPY = Number(target.split(";")[0]);
            this.CNYToJPY = Number(target.split(";")[1]);
            this.THBToJPY = Number(target.split(";")[2]);
            this.JPYToJPY = 1;
            this.dataProcess();

            Modal.showWarning("", t("message.NUMBER.RATE_UPDATE_SUCCESS"), {
              $type: "prompt",
              confirmButtonText: t("resource.button.sure"),
              cancelButtonText: t("resource.button.cancel"),
              showCancelButton: true,
            }).then(() => {
              this.confirmClick();
            });
          }
        }
      );

      // フォーカス削除
      this.$refs.rateReferenceBtn.$el.blur();
    },

    //見積書出力ボタン
    estimateOutputClick() {
      ShowEstimateInfoReferenceDialog(
        {
          nbQuoteNo: this.localNbQuoteNo,
        },
        t("resource.NUMBER.ESTIMATEINFO_REFERENCE_VIEW"),
        (target) => {
          if (target.key == "ok") {
            var estimateInfoForm = {
              nbQtnName: target.value.subject,
              nbQtnDueDate: target.value.deliveryDate,
              nbQtnPaymentTerms: target.value.paymentTerms,
              nbQtnDeadline: target.value.deadline,
              nbQtnDeliveryLocation: target.value.customerReceivingAddress,
              nbQtnRemarks: target.value.bikou,
            };

            editNumberInfoEsimateAndCompany({
              nbQuoteNo: this.localNbQuoteNo,
              estimateInfoForm: estimateInfoForm,
              nbUpdateTime: this.nbUpdateTime,
              user: getUserInfo().UserId,
            })
              .then((res) => {
                this.nbUpdateTime = res;

                Message.showSuccess(t("message.COMMON_MESSAGE.UPDATE_SUCCESS"));
                // this.searchNumberDetailCustomerByNbQuoteNoProc();

                this.showFlag = true;
                this.outputProcess(target.value.outType);
              })
              .catch((err) => {
                this.showFlag = false;
                if (err.data != null) {
                  Message.showError(
                    t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
                  );
                } else {
                  Message.showError(t("message.COMMON_MESSAGE.UPDATE_FAILURE"));
                }
              });
          }
        }
      );

      // フォーカス削除
      this.$refs.estimateOutputBtn.$el.blur();
    },

    outputProcess(data) {
      let selectedApi = "";
      if (data === "1") {
        selectedApi = httpApi.OutPutQuotationExcel;
      } else {
        selectedApi = httpApi.OutPutQuotationPdf;
      }

      outputExcelToZip(selectedApi, {
        nbQuoteNo: this.localNbQuoteNo,
      }).finally(() => {
        //見積状態の自動変更
        EditQuoteStateByQuoteNo({
          nbQuoteNo: this.nbQuoteNo,
          nbQuoteState: "9",
          user: getUserInfo().UserId,
          nbUpdateTime: this.nbUpdateTime,
        })
          .then((res) => {
            this.nbUpdateTime = res;
          })
          .catch((err) => {
            if (err.data != null) {
              Message.showError(
                t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
              );
            } else {
              Message.showError(t("message.COMMON_MESSAGE.UPDATE_FAILURE"));
            }
          })
          .finally(() => {
            this.searchNumberDetailCustomerByNbQuoteNoProc();
          });
      });
    },

    //セルの配置
    tableCellClassName({ row, column, rowIndex, columnIndex }) {
      row.index = rowIndex;
      column.index = columnIndex;

      //受注済みの場合、編集不可
      if (this.productNotEditFlg) {
        return "";
      }

      //編集可能な列:
      //「重量(kg/个)」
      //「加工_加工単価(JPY)」「加工_運賃（JPY/kg）」「加工_提成率（%）」
      //「処理1_加工単価(JPY)」「処理2_加工単価(JPY)」「処理3_加工単価(JPY)」
      //「粗利率(%)」「確定売価(JPY/個)」
      // 運賃 (元/个)
      var columnEditable = [
        "ndUWeight",
        "ndMUPrice",
        //"ndMTransportCost",
        "ndMCommissionRate",
        "ndP1UPrice",
        "ndP2UPrice",
        "ndP3UPrice",
        "ndGrossMargin",
        "ndUSetPrice",
        "ndMUTransportCostCny",
      ];

      //日本/本社工場の場合、運賃と提成率が編集不可
      if (row.ndMSupFactoryKbn && row.ndMSupFactoryKbn != FACTORY_KBN_DALIAN) {
        columnEditable = columnEditable.filter(
          (item) => item !== "ndMTransportCost" && item !== "ndMCommissionRate"
        );
      }

      //仕入先が空の場合、加工単価が編集不可
      if (this.isEmptyOrNull(row.ndP1SupCode)) {
        columnEditable = columnEditable.filter((item) => item !== "ndP1UPrice");
      }
      if (this.isEmptyOrNull(row.ndP2SupCode)) {
        columnEditable = columnEditable.filter((item) => item !== "ndP2UPrice");
      }
      if (this.isEmptyOrNull(row.ndP3SupCode)) {
        columnEditable = columnEditable.filter((item) => item !== "ndP3UPrice");
      }

      if (columnEditable.includes(column.property)) {
        //運賃(元/个)の背景色：数量,加工_加工単価(JPY)/レート,重量
        if (column.property == "ndMUTransportCostCny") {
          if (row.ndMSupFactoryKbn == FACTORY_KBN_DALIAN) {
            return this.calNdMUTransportCostCnyColor(
              row.ndProdQuantity,
              row.ndMUPrice,
              row.ndMExr,
              row.ndUWeight
            );
          } else {
            return "";
          }
        } else {
          //編集可能の背景色
          return "bg-cell-editable";
        }
      }
    },

    //レートを取得する
    getRateByCurType(oldRate, curType) {
      //レートを更新していない場合
      if (
        this.USDToJPY == 0 &&
        this.CNYToJPY == 0 &&
        this.THBToJPY == 0 &&
        this.JPYToJPY == 1
      ) {
        return oldRate;
      } else {
        if (curType == "USD") {
          return this.USDToJPY;
        } else if (curType == "CNY") {
          return this.CNYToJPY;
        } else if (curType == "THB") {
          return this.THBToJPY;
        } else if (curType == "JPY") {
          return this.JPYToJPY;
        } else {
          return 0;
        }
      }
    },

    //Enter処理
    focusNextInput(index, columnProp) {
      index = index + 1;

      if (index > this.customerTable.length - 1) {
        for (var i = 0; i < this.customerTable.length; i++) {
          if (this.$refs[`input${i}-${columnProp}`] !== undefined) {
            this.$refs[`input${i}-${columnProp}`][0].focus();
            break;
          }
        }
      } else {
        var i = index;
        for (i; i < this.customerTable.length; i++) {
          if (this.$refs[`input${i}-${columnProp}`] !== undefined) {
            this.$refs[`input${i}-${columnProp}`][0].focus();
            break;
          }
        }
        //下に入力ボックスがない場合は、最初から
        if (i == this.customerTable.length) {
          this.focusNextInput(-1, columnProp);
        }
      }
    },

    //値がNULLまたはnullです
    isEmptyOrNull(item) {
      if (item == undefined || item == STR_EMPTY) {
        return true;
      } else {
        return false;
      }
    },

    //運賃(元/个)の計算：加工_加工単価(JPY),加工_レート,重量
    calNdMUTransportCostCny(ndMUPrice, ndMExr, ndUWeight) {
      if (ndMUPrice <= 190 * ndMExr) {
        return formatStringToCurrency((ndMUPrice * 0.05) / ndMExr);
      } else if (ndMUPrice > 190 * ndMExr && ndMUPrice <= 500 * ndMExr) {
        return formatStringToCurrency((ndMUPrice * 0.08) / ndMExr);
      } else if (ndMUPrice > 500 * ndMExr && ndMUPrice < 700 * ndMExr) {
        return formatStringToCurrency((ndMUPrice * 0.1) / ndMExr);
      } else if (ndMUPrice >= 700 * ndMExr && ndMUPrice <= 1000 * ndMExr) {
        return formatStringToCurrency((ndMUPrice * 0.11) / ndMExr);
      } else if (ndMUPrice > 1000 * ndMExr) {
        return formatStringToCurrency(ndUWeight * 30);
      }
    },

    //運賃(元/个)の背景色：数量,加工_加工単価(JPY)/加工_レート,重量
    calNdMUTransportCostCnyColor(ndProdQuantity, ndMUPrice, ndMExr, ndUWeight) {
      if (ndProdQuantity >= 10) {
        //数量>＝10個：橙色
        return "bg-cell-editable";
      } else {
        if (
          formatCurrencyToNumber(ndMUPrice) / ndMExr == 0 ||
          this.isEmptyOrNull(ndMUPrice / ndMExr)
        ) {
          //数量<10個、加工_加工単価(CNY)= 0または空  :  赤色
          return "bg-cell-attention";
        } else if (
          formatCurrencyToNumber(ndMUPrice / ndMExr) > 0 &&
          formatCurrencyToNumber(ndMUPrice) <= 1000 * ndMExr
        ) {
          //数量<10個、0<加工_加工単価(CNY)<=1000 : 白
          return "";
        } else if (formatCurrencyToNumber(ndMUPrice) > 1000 * ndMExr) {
          if (this.isEmptyOrNull(ndUWeight)) {
            //数量<10個、加工_加工単価(CNY)>1000、重量が空 : 赤色
            return "bg-cell-attention";
          } else {
            //数量<10個、加工_加工単価(CNY)>1000、重量が非空 : 白
            return "";
          }
        }
      }
    },

    //テーブルで変更される可能性のある列の取得
    extract(data) {
      return data.map((item, index) => {
        return {
          index: index,
          ndProdDrawNo: item.ndProdDrawNo,
          ndProdName: item.ndProdName,
          ndUWeight: item.ndUWeight,
          ndMUPrice: item.ndMUPrice,
          ndMCommissionRate: item.ndMCommissionRate,
          ndP1UPrice: item.ndP1UPrice,
          ndP2UPrice: item.ndP2UPrice,
          ndP3UPrice: item.ndP3UPrice,
          ndGrossMargin: item.ndGrossMargin,
          ndUSetPrice: item.ndUSetPrice,
          ndMUTransportCostCny: item.ndMUTransportCostCny,
        };
      });
    },

    //ダイアログを閉じる
    onCancel() {
      var tmpTableData = JSON.parse(
        JSON.stringify(this.extract(this.customerTable))
      );
      if (!cmpDetailData(this.cmpDetailResult, tmpTableData)) {
        return new Promise((resolve, reject) => {
          Modal.showWarning(
            "",
            t("message.COMMON_MESSAGE.DATA_ALREADY_CHANGED_CLOSE"),
            {
              $type: "prompt",
              confirmButtonText: t("resource.button.sure"),
              cancelButtonText: t("resource.button.cancel"),
              showCancelButton: true,
            }
          )
            .then(() => {
              // 用户点击确认
              resolve(true);
            })
            .catch((error) => {
              // 用户点击取消或关闭对话框
              resolve(false);
            });
        });
      } else {
        return true;
      }
    },
  },
};
</script>
<style scoped>
::v-deep .el-table .current-row > td {
  background-color: #b2d8ff;
}
.el-form-item {
  margin-bottom: 5px;
}

.editCell {
  width: 100%;
  height: 17px;
  line-height: 0;
}

::v-deep .el-table.table_common .el-table__fixed {
  height: auto !important;
  bottom: 16px;
}
</style>
